<div class="mct-flex mct-col mct-gap-27" *ngIf="membershipLevelData">
  <div *ngFor="let item of membershipLevelData?.MembershipLevelItems">
    <div>
      <label>{{ item.RealName }}</label>
      <div class="mct-flex mct-row">
        <input name="displayName" type="text" [placeholder]="item.RealName" [(ngModel)]="item.DisplayName" class="form-control" />
        <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="removeItem(item)">
          {{ 'common.remove' | translate | uppercase }}
        </button>
      </div>
    </div>
  </div>
  <p-select
    name="membershipLevels"
    appendTo="body"
    [style]="{ width: '100%' }"
    [options]="membershipLevels"
    [(ngModel)]="selectedLevel"
    (onChange)="membershipLevelDropdownChanged()"
    [placeholder]="'common.select-one' | translate | ucfirst"
    [required]="true"
  ></p-select>
</div>
